import { Permission } from '../../access-control/permissions'
import { type DomainAccessControlConfig } from '../../utils/domain/accessControl'

export const TransactionLogsListPageAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.Tlogs,
  },
]
